
if (!customElements.get("shop-the-look-drawer")) {
  class ShopTheLookDrawer extends HTMLElement {
    constructor() {
      super();

      this._boundClose = this.close.bind(this);
      this._boundOnBlocksKeydown = this.handleBlocksKeydown.bind(this);
      this._boundOnTriggerClick = this.handleTriggerClick.bind(this);
      this._boundOnHostClick = this.handleHostClick.bind(this);
    }

    connectedCallback() {
      if (this._listenersBound) return;

      this._listenersBound = true;
      this.toggleState = false;

      const closeBtn = this.querySelector(".button--close");
      const blocks = this.querySelector(".shop-the-look-drawer__blocks");

      if (!closeBtn || !blocks) return;

      if (!this.classList.contains("is--open")) {
        document.body.classList.remove("overflow-hidden");
      }

      closeBtn.addEventListener("click", this._boundClose);
      this.addEventListener("click", this._boundOnHostClick);
      blocks.addEventListener("keydown", this._boundOnBlocksKeydown);

      document
        .querySelectorAll(
          `[aria-controls="${this.id}"].shop-the-look-drawer__trigger`,
        )
        .forEach((trigger) => {
          trigger.addEventListener("click", this._boundOnTriggerClick);
        });
    }

    handleTriggerClick(event) {
      event.preventDefault();
      this.open();
    }

    handleHostClick(event) {
      if (!this.toggleState) return;

      if (!event.target.closest(".shop-the-look-drawer__blocks")) {
        this.close();
      }
    }

    handleBlocksKeydown(event) {
      if (event.key === "Escape" && this.toggleState) {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.body.classList.add("overflow-hidden");
      this.classList.add("is--open");

      document
        .querySelectorAll(
          `[aria-controls="${this.id}"].shop-the-look-drawer__trigger`,
        )
        .forEach((btn) => {
          btn.setAttribute("aria-expanded", "true");
        });

      const firstFocusable = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      );

      if (firstFocusable) {
        firstFocusable.focus();
      }
    }

    close() {
      this.toggleState = false;
      document.body.classList.remove("overflow-hidden");
      this.classList.remove("is--open");

      document
        .querySelectorAll(
          `[aria-controls="${this.id}"].shop-the-look-drawer__trigger`,
        )
        .forEach((btn) => {
          btn.setAttribute("aria-expanded", "false");
        });
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }
  }

  customElements.define("shop-the-look-drawer", ShopTheLookDrawer);
}
